// src/contexts/AuthContext.jsx
import { createContext, useContext, useEffect, useState } from 'react';
import { auth } from '@/services/firebase';
import { onAuthStateChanged } from 'firebase/auth';
import { ProfileService } from '@/services/profile.service';

const AuthContext = createContext({});

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;

    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setUser(user);

      // If no user, we can stop loading
      if (!user) {
        setProfile(null);
        setLoading(false);
        return;
      }

      // If we have a user, fetch their profile
      ProfileService.getProfile()
        .then((profileData) => {
          if (!mounted) return;
          console.log('Fetched profile data:', profileData);
          const profileToSet = profileData?.profile || profileData;
          console.log('Setting profile to:', profileToSet);
          setProfile(profileToSet);
        })
        .catch((error) => {
          if (!mounted) return;
          console.error('Error fetching profile:', error);
          if (error.response?.status === 404) {
            setProfile(null);
          }
        })
        .finally(() => {
          if (!mounted) return;
          // Add a small delay before completing the loading state
          // This ensures the profile state is properly synchronized
          setTimeout(() => {
            setLoading(false);
          }, 100);
        });
    });

    return () => {
      mounted = false;
      unsubscribe();
    };
  }, []);

  const updateProfile = async (profileData) => {
    console.log('Updating profile with:', profileData);
    setProfile(profileData?.profile || profileData);
  };

  return (
    <AuthContext.Provider value={{ user, profile, loading, updateProfile }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
